import { useDispatch, useSelector } from 'react-redux';
import {
  deleteConsignmentOrderBilling,
  getConsignmentOrderBillingsByOrderId,
} from '../../../../appRedux/actions';
import { useCallback, useEffect, useState } from 'react';
import { Button, Table } from 'antd';
import { useParams } from 'react-router-dom';
import { formatPrice } from '../../../../util/formatPrice';
import { stringDate } from '../../../../util';
import { ConsignOrderBillingStatus } from '../ConsignmentOrderBillingStatus';
import { ConsignOrderBillingTableOptions } from '../ConsignmentOrderBillingOption';
import { ModalView } from '../../../uiComponents';
import { consignOrderBillingConst } from '../../../../constants/ConsignOrderBilling.const';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { ConsignOrderModalBillgBody } from '../ConsignmentOrderBillingModal';
import { consignOrderBillingStatusConst } from '../../../../constants/ConsignOrderBilling.const';

export const ConsignmentOrderBillingTable = ({
  privileges,
  role,
  numberOrder,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [modalTitle, setModalTitle] = useState(null);
  const [modalData, setModalData] = useState({});
  const { catalogId, setModal } = useCustomModal();
  const { consignmentOrderByConsigmentOrder } = useSelector(
    (state) => state.consignmentOrderBilling
  );
  const getConsignmentOrderByConsigmentOrder = useCallback(() => {
    if (id) {
      dispatch(getConsignmentOrderBillingsByOrderId(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    getConsignmentOrderByConsigmentOrder();
  }, [getConsignmentOrderByConsigmentOrder]);

  const getStatus = (record) => {
    const status = record.deletedAt
      ? consignOrderBillingStatusConst.CANCELED
      : record.status;
    return <ConsignOrderBillingStatus status={status} />;
  };

  const onDelete = async (id) => {
    await dispatch(deleteConsignmentOrderBilling(id));
    getConsignmentOrderByConsigmentOrder();
  };

  useEffect(() => {
    if (!modalData) return;

    setModalTitle(
      `${consignOrderBillingConst.header}: ${modalData.billingNumber}`
    );
  },[modalData]);

  const columns = [
    {
      title: 'Número de Factura',
      dataIndex: 'billingNumber',
      key: 'billingNumber',
      render: (billingNumber, record) => (
        <Button
          type="link"
          htmlType="button"
          onClick={() => {
            setModal(record.id);
            setModalData(record);
          }}
        >
          {`FC${billingNumber}`}
        </Button>
      ),
    },
    {
      title: 'Estado',
      key: 'status',
      render: (_, record) => {
        return getStatus(record);
      },
    },
    {
      title: 'Fecha de creación',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => stringDate(createdAt),
    },
    {
      title: 'Metodo de pago',
      dataIndex: 'payMethod',
      key: 'payMethod',
    },
    {
      title: 'Fecha de pago',
      dataIndex: 'paidAt',
      key: 'paidAt',
      render: (paidAt) => stringDate(paidAt),
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (total) => `${formatPrice(total || '0')}`,
    },
    {
      title: 'Opciones',
      key: 'actions',
      render: (_, record) => (
        <ConsignOrderBillingTableOptions
          id={record.id}
          action={{
            onDelete: {
              action: onDelete,
              params: [record.id],
            },
          }}
          privileges={privileges}
          status={record.status}
          role={role}
          numberOrder={numberOrder}
          consignmentOrderId={id}
        />
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={consignmentOrderByConsigmentOrder}
        columns={columns}
        rowKey={(row) => row.id}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 40, 60],
        }}
      />
      <ModalView title={modalTitle} width={900}>
        <ConsignOrderModalBillgBody data={modalData} />
      </ModalView>
    </>
  );
};
